// extracted by mini-css-extract-plugin
export default {"formWrapper":"activity_edit_form-module___formWrapper___a7b8bb13","confirmModalText":"activity_edit_form-module___confirmModalText___dedc3263"};